import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=0493fb39"
import script from "./nav-menu.vue?vue&type=script&lang=js"
export * from "./nav-menu.vue?vue&type=script&lang=js"
import style0 from "./nav-menu.vue?vue&type=style&index=0&id=0493fb39&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports